import { useState, useEffect, useRef, useCallback } from 'react';

/**
 * Hook 用于跟踪正文编辑状态
 * 基于 onEditorChange 事件，如果超过指定时间（默认10秒）没有触发编辑，则认为不在编辑状态
 */
export function useContentEditingStatus(noEditTimeout: number = 10000) {
  const [isContentEditing, setIsContentEditing] = useState(false);
  const noEditTimerRef = useRef<NodeJS.Timeout | null>(null);

  /**
   * 通知内容正在编辑
   */
  const notifyContentEditing = useCallback(() => {
    // 设置为正在编辑
    setIsContentEditing(true);

    // 清除之前的定时器
    if (noEditTimerRef.current) {
      clearTimeout(noEditTimerRef.current);
      noEditTimerRef.current = null;
    }

    // 设置新的定时器，超过指定时间无编辑则认为不在编辑状态
    noEditTimerRef.current = setTimeout(() => {
      setIsContentEditing(false);
      noEditTimerRef.current = null;
      console.log('Content editing timeout, set isContentEditing to false');
    }, noEditTimeout);
  }, [noEditTimeout]);

  /**
   * 清理定时器
   */
  useEffect(() => {
    return () => {
      if (noEditTimerRef.current) {
        clearTimeout(noEditTimerRef.current);
        noEditTimerRef.current = null;
      }
    };
  }, []);

  return {
    isContentEditing,
    notifyContentEditing,
  };
}
